import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowDownSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.005 8.341 2.03 4.366l.707-.707 3.268 3.268 3.268-3.268.707.707-3.975 3.975Z"
    />
  </svg>
);
export default IconArrowDownSizeXs;
